import React from 'react';
import { ExternalLink, PlayCircle } from 'lucide-react';
import { getPublishedTutorialVideos, youtubeEmbedUrl } from '../data/tutorialVideos';

export default function TutorialVideos() {
  const videos = getPublishedTutorialVideos();
  if (videos.length === 0) return null;

  return (
    <section id="videos" className="mb-16 scroll-mt-20">
      <div className="flex items-center justify-between gap-4 mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-800 flex items-center">
            <span className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center mr-3">
              <PlayCircle size={17} strokeWidth={2.4} />
            </span>
            Videos tutoriales
          </h2>
          <p className="text-gray-600 text-sm mt-2">
            Guías visuales oficiales para complementar el manual paso a paso.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {videos.map((video) => {
          const embedUrl = youtubeEmbedUrl(video.youtubeUrl);
          return (
            <article key={video.key} className="bg-white border border-gray-100 rounded-xl shadow-sm overflow-hidden">
              {embedUrl && (
                <div className={video.format === '9:16' ? 'aspect-[9/16] max-h-[540px] bg-gray-900' : 'aspect-video bg-gray-900'}>
                  <iframe
                    src={embedUrl}
                    title={video.title}
                    loading="lazy"
                    className="w-full h-full"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                </div>
              )}
              <div className="p-5">
                <div className="text-xs font-semibold uppercase tracking-wide text-blue-600 mb-2">
                  {video.topic} · {video.format}
                </div>
                <h3 className="font-semibold text-gray-800 mb-2">{video.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">{video.description}</p>
                <a
                  href={video.youtubeUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-blue-600 hover:text-blue-800 text-sm font-semibold hover:underline"
                >
                  Abrir en YouTube
                  <ExternalLink size={14} className="ml-1.5" />
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
